import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { CreateForgotPasswordMutationRequest, CreateForgotPasswordMutationResponse, CreateForgotPassword400, CreateForgotPassword500 } from "../types/CreateForgotPassword";
import type { UseMutationOptions } from "@tanstack/react-query";

 type CreateForgotPasswordClient = typeof client<CreateForgotPasswordMutationResponse, CreateForgotPassword400 | CreateForgotPassword500, CreateForgotPasswordMutationRequest>;
type CreateForgotPassword = {
    data: CreateForgotPasswordMutationResponse;
    error: CreateForgotPassword400 | CreateForgotPassword500;
    request: CreateForgotPasswordMutationRequest;
    pathParams: never;
    queryParams: never;
    headerParams: never;
    response: CreateForgotPasswordMutationResponse;
    client: {
        parameters: Partial<Parameters<CreateForgotPasswordClient>[0]>;
        return: Awaited<ReturnType<CreateForgotPasswordClient>>;
    };
};
/**
 * @summary Forgot password
 * @link /api/forgot-password
 */
export function useCreateForgotPassword(options: {
    mutation?: UseMutationOptions<CreateForgotPassword["response"], CreateForgotPassword["error"], CreateForgotPassword["request"]>;
    client?: CreateForgotPassword["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async (data) => {
            const res = await client<CreateForgotPassword["data"], CreateForgotPassword["error"], CreateForgotPassword["request"]>({
                method: "post",
                url: `/api/forgot-password`,
                data,
                headers: { "Content-Type": "text/json", ...clientOptions.headers },
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}